export const rem = (px: number, basePx = 16): string => `${px / basePx}rem`;
